var _rect, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlurries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flurries",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "none",
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M5.25,15.5c-1.5166,0-2.75-1.2334-2.75-2.75 c0-1.1265,0.6777-2.127,1.7266-2.5483l0.3506-0.1406l-0.04-0.3755C4.5137,9.4609,4.5,9.2324,4.5,9c0-3.584,2.916-6.5,6.5-6.5 c2.9912,0,5.583,2.0288,6.3018,4.9331l0.0908,0.3677l0.3789,0.0117C19.8623,7.8789,21.5,9.5645,21.5,11.6499 c0,2.123-1.7275,3.8501-3.8506,3.8501H5.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D33",
    d: "M10.9999,2.9999c2.7609,0,5.1527,1.8724,5.8163,4.5533l0.182,0.7352l0.757,0.024 c1.8195,0.0577,3.2447,1.5237,3.2447,3.3376c0,1.8472-1.5028,3.35-3.35,3.35h-12.4c-1.2407,0-2.25-1.0094-2.25-2.2501 c0-0.921,0.5546-1.7391,1.413-2.0842l0.6992-0.2811L5.0346,9.6352C5.0113,9.4094,4.9999,9.2016,4.9999,9 C4.9999,5.6916,7.6915,2.9999,10.9999,2.9999 M10.9999,1.9999c-3.866,0-7,3.1331-7,7.0001c0,0.2501,0.015,0.4961,0.04,0.738 c-1.194,0.48-2.04,1.6451-2.04,3.012c0,1.794,1.455,3.2501,3.25,3.2501h12.4c2.403,0,4.35-1.9481,4.35-4.35 c0-2.3561-1.875-4.263-4.213-4.3372C17.0319,4.263,14.2839,1.9999,10.9999,1.9999L10.9999,1.9999z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0072F5",
    d: "M13.8164,19.6602L13,20.1316l0.8164,0.4714c0.2393,0.1382,0.3213,0.4438,0.1826,0.6831 c-0.1377,0.2407-0.4443,0.3213-0.6826,0.1831L12.5,20.9978v0.9431c0,0.2764-0.2236,0.5-0.5,0.5s-0.5-0.2236-0.5-0.5v-0.9431 l-0.8164,0.4714c-0.2383,0.1367-0.5449,0.0566-0.6826-0.1831c-0.1387-0.2393-0.0566-0.5449,0.1826-0.6831L11,20.1316l-0.8164-0.4714 c-0.2393-0.1382-0.3213-0.4438-0.1826-0.6831c0.0918-0.1606,0.2607-0.25,0.4326-0.25c0.085,0,0.1709,0.0215,0.25,0.0669 L11.5,19.2654v-0.9431c0-0.2764,0.2236-0.5,0.5-0.5s0.5,0.2236,0.5,0.5v0.9431l0.8164-0.4714 c0.0791-0.0454,0.165-0.0669,0.25-0.0669c0.1719,0,0.3408,0.0894,0.4326,0.25C14.1377,19.2163,14.0557,19.522,13.8164,19.6602z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlurries);
export default __webpack_public_path__ + "static/media/flurries.6895fe846df4a02888078aaf53fff630.svg";
export { ForwardRef as ReactComponent };